import { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import Cookies from 'js-cookie';

const useFetch = (initialUrl = null, autoFetch = true) => {
  const [url, setUrl] = useState(initialUrl);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const cancelTokenSource = useRef(null);

  const fetchData = useCallback(async (requestUrl = url) => {
    if (!requestUrl) return;

    if (cancelTokenSource.current) {
      cancelTokenSource.current.cancel("Cancelled previous request.");
    }

    cancelTokenSource.current = axios.CancelToken.source();
    setIsLoading(true);

    try {
      const accessToken = Cookies.get('access_token');

      const res = await axios.get(requestUrl, {
        cancelToken: cancelTokenSource.current.token,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
        },
      });

      setData(res.data);
      setErrorMessage(null);
    } catch (err) {
      if (!axios.isCancel(err)) {
        setErrorMessage(err);
      }
    } finally {
      setIsLoading(false);
    }
  }, [url]);

  useEffect(() => {
    if (autoFetch && url) {
      fetchData(url);
    }
    return () => {
      if (cancelTokenSource.current) {
        cancelTokenSource.current.cancel("Component unmounted");
      }
    };
  }, [url, autoFetch, fetchData]);

  return { data, isLoading, errorMessage, fetchData, setUrl };
};

export default useFetch;
